import { render, staticRenderFns } from "./PromoteSet.vue?vue&type=template&id=0b60ba23&scoped=true"
import script from "./PromoteSet.vue?vue&type=script&lang=js"
export * from "./PromoteSet.vue?vue&type=script&lang=js"
import style0 from "./PromoteSet.vue?vue&type=style&index=0&id=0b60ba23&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b60ba23",
  null
  
)

export default component.exports